<!--

-->
<template>
  <div>
    <div class="replacement_item_form">
      <!-- Subtitle -->
      <div v-if="!loading">
        <h2 class="subtitle">{{ $t(`${pagei18nKey}.title`) }}</h2>
        <div v-if="replacementOptions && replacementOptions.length > 0">
          <p>{{ $t(`${pagei18nKey}.notRepairable`) }}</p>
          <p class="replacement_item_form__label">{{ $t(`${pagei18nKey}.chooseReplacement`) }}</p>
          <app-replacement-item
            v-for="(option, index) in replacementOptions"
            :key="index"
            class="replacement_item__checkbox"
            :uncheckedSrc="'/static/theme/img/checkbox-unchecked-secondary.png'"
            :checkedSrc="'/static/theme/img/checkbox-checked.png'"
            :caption="getCaptionForItem(replacementOptions[index])"
            :image="`${option.photo}`"
            :selected.sync="imageChecked[index]"
            :selectVal.sync="selectedReplacementOption.colorIndex"
            :selectOptions="replacementOptions[index].colors"
            :selectDisplayKey="'value'"
            :selectPlaceholder="$t(`${pagei18nKey}.chooseReplacementColour`)"
            :selectAltColourVal.sync="selectedReplacementOption.altColorIndexes"
            :selectAltColourOptions="replacementOptions[index].colors"
            :selectAltColourDisplayKey="'value'"
            :selectAltColourPlaceholder="$t(`${pagei18nKey}.chooseReplacementAltColour`)"
            :disclaimerHeader="$t(`${pagei18nKey}.disclaimerHeader`)"
            :disclaimerText="$t(`${pagei18nKey}.disclaimerText`)"
            @change="onCheckboxClicked(index)"
          />      
          <div v-if="replacementOptions && replacementOptions.length > 0"
            class="replacement-advisory">
            <div class="replacement-advisory-message">
              {{ $t(`${pagei18nKey}.advisoryText`) }}
            </div>
          </div>
          <!-- <app-image-checkbox
            class="replacement_item__checkbox"
            :uncheckedSrc="'/static/theme/img/checkbox-unchecked-secondary.png'"
            :checkedSrc="'/static/theme/img/checkbox-checked.png'"
            :caption="$t(`${pagei18nKey}.noReplacementText`)"
            :selected.sync="noReplacementChecked"
            @change="onCheckboxClicked(null)"
          /> -->

          <div v-if="replacementOptions && replacementOptions.length > 0"
            class="replacement-advisory">
            <div class="replacement-advisory-message">
              {{ $t(`${pagei18nKey}.additionalInfo`) }}
            </div>
          </div>


        </div>
        <div class="replacement-not-found" v-else>
          <div class="replacement-not-found-message">
            {{ $t(`${pagei18nKey}.noReplacementOptions`) }}
          </div>
        </div>
      </div>

      <div v-else>
        <div class="loading-div" v-if="loading">
          <img class="spinner" :src="loadingSpinner"/>
        </div>
      </div>

    </div>
    <!-- Navigation buttons -->
    <div class="replacement_item_button__container">
      <ms-navigation-bar
        :buttons="[backButton, nextButton]"
        @navigationButtonClick="navigationButtonClick"
      />
    </div>

  </div>
</template>
<script>
  import api from '@/api/api'
  import AppSettings from '@/app-settings.json'
  import themeSettings from '@/theme-settings.json'
  import AppButton, {ButtonStates} from '@/components/app-button'
  import AppImageCheckbox from '@/components/app-image-checkbox'
  import AppReplacementItem from '@/components/app-replacement-item'
  import MsNavigationBar, {DefaultNavigationButtons} from '@/components/ms-navigation-bar'
  import {BaggageItem} from '../../model/baggageItem'
  import {StockReplacementRequest, StockReplacementRequestClaimInfo} from '../../model/api/stockReplacementRequest'

  export default {
    name: 'ReplacementItemView',
    components: {
      AppButton,
      MsNavigationBar,
      AppImageCheckbox,
      AppReplacementItem
    },
    data: function () {
      return {
        loadingSpinner: AppSettings.submitInProgress,
        loading: false,
        pagei18nKey: 'message.replacementItem',
        currentItem: null,
        currentIndex: this.index && !isNaN(parseInt(this.index)) ? parseInt(this.index) : null,
        imageChecked: { // Max 3 options
          0: false,
          1: false,
          2: false
        },
        noReplacementChecked: false,
        // eslint-disable-next-line comma-spacing,quotes,key-spacing
        // replacementOptions: [{"id":180,"dateCreated":1560511783916,"size":68,"photo":"https://firebasestorage.googleapis.com/v0/b/damaged-luggage-claims-client.appspot.com/o/images%2Fstock_items%2Fa4059297-270c-4258-b3d1-ef92fae2e78c?alt=media&token=e22829e3-9ac0-42b6-a8cb-381c717fd5c9","name":"Style DL332","materialName":"Soft Shell Trolley Suitcase","wheelName":"2","mainDescription":"2 front pockets, expanding, fully lined","colors":[{"id":15,"value":"Red"},{"id":16,"value":"Blue"},{"id":17,"value":"Orange"},{"id":18,"value":"Black"}]}],
        replacementOptions: null,
        selectedReplacementOption: {
          baggageItem: null,
          replacementItem: null,
          colorId: null,
          altColorIds: null,
          colorIndex: null,
          altColorIndexes: null
        }
      }
    },
    props: {
      arrayName: String,
      index: [Number, String]
    },
    /**
     * Check whether we have route props and if they match a given object in
     * item array then set relevant props to pass through to form components
     */
    beforeMount () {
      if (this.currentIndex !== null) {
        const array = this.$store.getters[this.arrayName]
        if (
          array !== undefined &&
          array[this.currentIndex] !== undefined
        ) {
          this.currentItem = array[this.currentIndex]
        }

        this.baggageItem = this.$store.getters.baggageItems[this.currentIndex]

        // Object for the API replacements endpoint, so the most suitable replacement items could be offered
        let baggageItemObject = BaggageItem.BaggageItemFromFlat({...this.baggageItem})

        // Get flight date from store and claim provider from theme settings
        const flightDate = this.$store.getters.flightDate
        const claimProviderId = themeSettings.claimProviderId

        // Create the request payload with baggage item and claim info (flight date, provider)
        const claimInfo = new StockReplacementRequestClaimInfo(flightDate, claimProviderId)
        const replacementRequest = new StockReplacementRequest(baggageItemObject, claimInfo)

        this.selectedReplacementOption.baggageItem = this.currentIndex
        this.loading = true
        api.getReplacementOptions(replacementRequest)
          .then(response => {
            this.replacementOptions = response.data
            this.loading = false

            // If the item is repairable
            if (this.replacementOptions && this.replacementOptions.isRepairable) {
              this.$store.commit('setBaggageReplacementOption', this.selectedReplacementOption)
              this.noReplacementChecked = true
            // If no options were found, push the user forward
            } else if (!this.replacementOptions || this.replacementOptions.length === 0) {
              this.$store.commit('setBaggageReplacementOption', this.selectedReplacementOption)
              this.$router.replace('/claims-items-summary')
            } else {
              // Check if the user has previously selected one of the options (editing item)
              if (this.baggageItem.replacementChosen) {
                if (this.baggageItem.replacementVariantId === null) { // If no replacement were chosen before
                  this.noReplacementChecked = true
                } else {
                  for (let i = 0; i < this.replacementOptions.length; i++) {
                    if (parseInt(this.replacementOptions[i].id) === parseInt(this.baggageItem.replacementVariantId)) {
                      this.imageChecked[i] = true
                      this.selectedReplacementOption.replacementItem = this.replacementOptions[i]
                      break
                    }
                  }
                }
              }
            }
          })
          .catch(error => {
            console.error(error)
            this.loading = false

            // If an error happened, select no replacement chosen
            this.$store.commit('setBaggageReplacementOption', this.selectedReplacementOption)
            this.$router.replace('/claims-items-summary')
          })
      }
    },
    computed: {
      /**
       * Get back button object
       */
      backButton: {
        get () {
          return DefaultNavigationButtons.BACK
        }
      },

      /**
       * Get next button object
       */
      nextButton: {
        get () {
          // Clone DefaultNavigationButtons.NEXT and remove reference to it
          let defaultNextButton = JSON.parse(JSON.stringify(DefaultNavigationButtons.NEXT))
          return Object.assign(
            defaultNextButton,
            {
              state: this.isFormValid ? ButtonStates.ENABLED : ButtonStates.DISABLED
            }
          )
        }
      },
      /**
       * Checks each form field to see if the form is valid
       *
       * @returns {boolean} Whether form is valid
       */
      isFormValid () {
        let valid = this.imageChecked[0] || this.imageChecked[1] || this.imageChecked[2] || this.noReplacementChecked
        // if we have colors for the selected bag then check one is selected
        if (this.selectedReplacementOption.replacementItem &&
          this.selectedReplacementOption.replacementItem.colors &&
          this.selectedReplacementOption.replacementItem.colors.length > 0) {
          valid = valid && this.selectedReplacementOption.colorIndex !== null
          // if valid and a colour has been chosen we get the id of the color from the color options
          // TODO this would make more sense to be handled in a callback for changes to selected colour
          if (this.selectedReplacementOption.colorIndex !== null && this.selectedReplacementOption.colorIndex >= 0) {
            this.selectedReplacementOption.colorId = this.selectedReplacementOption.replacementItem.colors[this.selectedReplacementOption.colorIndex].id
          } else {
            this.selectedReplacementOption.colorId = null
          }
          // there are alt colours to assign ids to replacement
          if (this.selectedReplacementOption.altColorIndexes !== null &&
          this.selectedReplacementOption.altColorIndexes.length >= 0) {
            this.selectedReplacementOption.altColorIds = []
            // loop over all indexes and get IDs
            for (let i = 0; i < this.selectedReplacementOption.altColorIndexes.length; i++) {
              const newColorId = this.selectedReplacementOption.replacementItem.colors[this.selectedReplacementOption.altColorIndexes[i]].id
              this.selectedReplacementOption.altColorIds.push(newColorId)
            }
          } else {
            this.selectedReplacementOption.altColorIds = null
          }
          // and make sure store is in sync
          this.$store.commit('setBaggageReplacementOption', this.selectedReplacementOption)
        }
        return valid
      }
    },
    methods: {
      /**
       * Gets caption for the given stock item
       */
      getCaptionForItem (item) {
        let captionItems = []
        if (item.name) captionItems.push(this.tryTranslate('message.apiTranslations', item.name))
        if (item.materialName) captionItems.push(this.tryTranslate('message.apiTranslations', item.materialName))
        if (item.size) captionItems.push(item.size)

        let caption = ''
        for (let i = 0; i < captionItems.length; i++) {
          if (i + 1 < captionItems.length) {
            caption += captionItems[i] + ', '
          } else {
            caption += captionItems[i]
          }
        }

        if (item.mainDescription) {
          if (caption.length > 0) {
            caption += `. ${this.tryTranslate('message.apiTranslations', item.mainDescription)}`
          } else {
            caption += `${this.tryTranslate('message.apiTranslations', item.mainDescription)}`
          }
        }

        return caption
      },

      /**
       * i18n doesn't have fallback to plain string option, this function does that instead.
       * Takes path to the translations and tries to translate
       * provided API string. If it doesn't find it, fallbacks to the provided one
       * @param {string} translationPath - e.g 'message.apiTranslations'
       * @param {string} stringToTranslate
       */
      tryTranslate (translationPath, stringToTranslate) {
        let translation = this.$t(`${translationPath}["${stringToTranslate}"]`)

        // In case of unsuccessful translation, translation contains message path
        return translation.includes(translationPath) ? stringToTranslate : translation
      },

      /**
       * Change route
       *
       * @param {string} buttonId - Id of button
       */
      navigationButtonClick (buttonId) {
        if (buttonId === DefaultNavigationButtons.BACK.id) {
          this.$router.replace(`/add-claims-item/baggageItems/${this.currentIndex}`)
        } else if (buttonId === DefaultNavigationButtons.NEXT.id) {
          this.$router.replace('/claims-items-summary')
        }
      },

      onCheckboxClicked (index) {
        // reset any chosen color
        this.selectedReplacementOption.colorIndex = null
        this.selectedReplacementOption.colorId = null
        this.selectedReplacementOption.altColorIndexes = null
        this.selectedReplacementOption.altColorIds = null
        // If no replacement chosen, uncheck all other boxes
        if (index === null) {
          this.selectedReplacementOption.replacementItem = null
          Object.keys(this.imageChecked).forEach((key, value) => {
            this.imageChecked[key] = false
          })
        } else {
          Object.keys(this.imageChecked).forEach((key, value) => {
            if (parseInt(key) !== parseInt(index)) {
              this.imageChecked[key] = false
            } else {
              this.noReplacementChecked = false

              // If the checkbox was unchecked
              if (!this.imageChecked[key]) {
                this.selectedReplacementOption.replacementItem = null
              } else {
                this.selectedReplacementOption.replacementItem = this.replacementOptions[key]
              }
            }
          })
        }
        this.$store.commit('setBaggageReplacementOption', this.selectedReplacementOption)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/main.scss";

  .replacement_item_button__container {
    @include mobile {
      padding: 0 $dims-horizontal-gutter;
    }
  }

  .replacement_item_form__label {
    font-weight: $semibold-font-weight;
  }

  .replacement_item_form {
    @extend %app_form_container;
    p {
      padding-bottom: $dims-padding-default;
    }
  }

  .replacement_item__checkbox {
    margin-top: $dims-padding-default;
  }

  .replacement_item__checkbox:first-of-type {
    margin-top: 0;
  }

  .loading-div {
    position: relative;
    height: 100px;

    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .replacement-advisory {
    margin-top: $dims-padding-default;
  }

  .replacement-not-found, .replacement-advisory {
    padding: $dims-padding-default;
    border: 1px solid #dddddd;
    background: $secondary-brand-color;
  }

  .replacement_item_form_additional_info_section {
    padding-top: $dims-padding-default;
  }

</style>
